import { capitalize } from '@caresend/utils';
import { defineComponent, computed, watch } from 'vue';
import __vue_component__ from '../../../../../components/buttons/ButtonComponent/ButtonComponent.vue.js';
import { buildMaybePartnerRoute } from '../../../../../router/helpers/builders.js';
import { getRoute, getRouter } from '../../../../../router/helpers/initRouter.js';
import '../../../../../router/routes/dev/model.js';
import '../../../../../router/routes/dev/routes.js';
import '../../../../../router/routes/dashboard/model.js';
import '../../../../../router/routes/pro/model.js';
import '../../../../../router/routes/visitsPage/model.js';
import '@caresend/types';
import '../../../../../router/routes/orderFlow/model.js';
import '../../../../../router/routes/orderFlow/privateHelpers.js';
import '../../../../../router/routes/orderFlow/routes.js';
import { SchedulingFlowRouteName } from '../../../../../router/routes/schedulingFlow/model.js';
import '../../../../../router/routes/schedulingFlow/routes.js';
import '../../../../../router/routes/chartingFlow/model.js';
import '../../../../../router/routes/chartingFlow/routes.js';
import '../../../../../router/routes/portal/portalRoutes.js';
import '../../../../../router/routes/portal/model.js';
import '../../../../../router/routes/visitsPage/routes.js';
import { getStore } from '../../../../helpers/initStore.js';

var script = defineComponent({
    name: 'VisitTypeTabs',
    components: {
        ButtonComponent: __vue_component__,
    },
    setup() {
        const route = getRoute();
        const initVisitTypeTab = (id) => ({
            id,
            title: capitalize(id),
        });
        const visitTypeTabs = computed(() => [
            initVisitTypeTab('home'),
            initVisitTypeTab('lab'),
        ]);
        const activeTabID = computed(() => {
            const { visitType } = route.value.params;
            return (visitType !== null && visitType !== void 0 ? visitType : 'home');
        });
        const getClassNamesByTabID = (tabID) => {
            if (activeTabID.value === tabID)
                return ['VisitTypeTabs__tab--active'];
            return [];
        };
        const store = getStore();
        const router = getRouter();
        const updateStoreForVisitTypeChange = (newVisitType, oldVisitType) => {
            const changedToLabFromHome = newVisitType === 'lab' && oldVisitType === 'home';
            const changedToHomeFromLab = newVisitType === 'home' && oldVisitType === 'lab';
            /** This component determines this value so we should set it here */
            store.commit('schedulingFlow/SET_IS_BRICK_AND_MORTAR', newVisitType === 'lab');
            if (changedToHomeFromLab) {
                /**
                 * Clear selected draw place ID when navigating to home tab
                 * since that is for the lab selection
                 */
                store.commit('schedulingFlow/SET_SELECTED_DRAW_PLACE_ID', undefined);
            }
            if (changedToLabFromHome) {
                /**
                 * Clear selected time slot when switching from home to lab
                 * since that is for the home selection
                 */
                store.commit('schedulingFlow/SET_SELECTED_TIME_SLOT', undefined);
            }
        };
        const handleTabClick = (tabID) => {
            var _a;
            const { name, params } = route.value;
            // If the current route is not the time step, we need to build the route to the time step.
            if (name !== SchedulingFlowRouteName.SCHEDULING_FLOW_TIME) {
                const routeToPush = buildMaybePartnerRoute({
                    name: SchedulingFlowRouteName.SCHEDULING_FLOW_TIME,
                    params: { visitType: tabID, draftWaypointID: (_a = params.draftWaypointID) !== null && _a !== void 0 ? _a : null },
                });
                router.push(routeToPush);
            }
            else {
                router.push({ params: { visitType: tabID } });
            }
        };
        const scrollToTop = () => {
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: 'smooth',
            });
        };
        watch(() => route.value.params.visitType, () => {
            scrollToTop();
        });
        // Watch for visit type changes and update store accordingly
        watch(activeTabID, (newVisitType, oldVisitType) => {
            updateStoreForVisitTypeChange(newVisitType, oldVisitType);
        });
        return {
            activeTabID,
            getClassNamesByTabID,
            handleTabClick,
            visitTypeTabs,
        };
    },
});

export { script as default };
